import styled from "styled-components";

export const NavContainer = styled.nav`
  height: 100%;

  .navLinks {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    li {
      button {
        span {
          display: none;
        }
      }
    }
  }

  @media (min-width: 1024px) {
    .navLinks {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      li {
        button {
          height: 4rem;
          width: 14rem;

          margin: 1.5rem 0;

          border-radius: 0.7rem;

          .content {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 1.5rem;
            span {
              display: inline;
              margin-left: 1rem;
            }
          }
        }
        button:hover {
          background-color: #daf4ff;
        }
      }
    }
  }
`;

export const HeaderContainer = styled.nav`
  background-color: var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  .heading__logo {
    display: flex;
    align-items: center;


  }

  .heading__logo--name {
    margin-left: 10%;
    display: none;
  }

  .heading__dropdown {
    margin-bottom: 2rem;

    span:nth-child(1) {
      margin-right: 0.8rem;
    }
  }


  @media (min-width: 1024px) {
    
  .heading__logo--name {
    display: inline-block ;
  }
  }

`;
